<template>
  <div class="page-dialog-with-action" v-if="msgDialogShow" ref="MsgWithActionDialogPage">
    <div class="content-dialog-with-action" ref="MsgWithActionDialogContent">
      <div class="concrete-content" v-text="msg">

      </div>
      <div :class="'btm-action-panel '+(type==1?'single':'double')" v-if="[1,2].indexOf(type)!=-1">
        <div class="action" v-for="(item,index) in btns" v-text="item" @click="doAction(index)"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'msg-dialog',
  props: {
    msgDialogShow: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    btns: {
      type: Array,
      default: []
    },
    hideFromOutSide: {
      type: Boolean,
      default: true,
    },
    extra: ''
  },
  methods: {
    doAction (index) {
      this.$emit('msgAction' + (index + 1), this.extra)
    },
    hideMsgWithSelf () {
      this.$emit('hideMsgWithActionDialog')
    },
    bodyMsgWithActionDialog (e) {
      let self = this
      if (this.$refs.MsgWithActionDialogContent && !this.$refs.MsgWithActionDialogContent.contains(e.target)) {
        self.hideMsgWithSelf()
      }
    },
  },
  watch: {
    msgDialogShow (n, o) {
      if (n) {
        let target = this
        setTimeout(function () {
          if (target.hideFromOutSide) {
            target.$refs.MsgWithActionDialogPage.addEventListener('click', target.bodyMsgWithActionDialog)
          }
        }, 100)
      } else {
        if (this.hideFromOutSide) {
          this.$refs.MsgWithActionDialogPage.removeEventListener('click', this.bodyMsgWithActionDialog)
        }
      }
    }
  },
}
</script>

<style scoped lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";

.page-dialog-with-action {
  position: fixed;
  z-index: 1001;
  margin: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);

  .content-dialog-with-action {
    .maxw(660);
    .minw(500);
    .b-radius(20);

    top: 50%;
    position: fixed;
    transform: translate(calc(50vw - 50%), -50%);

    .concrete-content {
      .fs(30);
      .padding(30, 40, 20, 40);
      .lh(40);
      .minh(50);
      font-family: Gilroy-Medium;
      font-weight: bold;
      background: #fff;
      .b-radius(20, 20, 0, 0);
    }

    .btm-action-panel.single {
      //background: #42b983;
      background: #FF0E74;
      .h(80);
      color: white;
      .b-radius(0, 0, 20, 20);

      .action {
        .fs(40);
        .lh(80);
        font-weight: bold;
        cursor: pointer;
      }

    }

    .btm-action-panel.double {
      .h(80);
      color: white;
      font-size: 0;

      .action {
        .fs(40);
        .lh(80);
        font-weight: bold;
        width: 50%;
        display: inline-block;
        font-weight: bold;
        cursor: pointer;
      }

      .action:first-child {
        .b-radius(0, 0, 0, 20);
        background: #f99b4a;
      }

      .action:last-child {
        .b-radius(0, 0, 20, 0);
        background: #42b983;
      }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/widget/msgdialog.vue